module.exports = __webpack_public_path__ + "img/line-levang-p.08a1f37e.webp";